import type { HtmlFragmentDefinition } from '#shared/model/html'

export function htmlFragmentToString(fragment: HtmlFragmentDefinition | undefined | null): string {
  if (!fragment) return ''

  if (typeof fragment === 'string') return fragment
  if (typeof fragment === 'number') return fragment.toString()
  if (Array.isArray(fragment)) return fragment.map(htmlFragmentToString).join('')
  return htmlFragmentToString(fragment.content)
}
